<template>
  <div>
    <v-card class="mx-auto mt-4" max-width="98%" elevation="2">
      <v-toolbar color="#37474F" dark flat>
        <v-icon left>mdi-swap-horizontal</v-icon>
        <v-toolbar-title>교환소</v-toolbar-title>
      </v-toolbar>
      <v-tabs
        v-model="activeTab"
        background-color="#455A64"
        dark
        show-arrows
        slider-color="light-blue accent-2"
      >
        <v-tab><v-icon left small>mdi-currency-krw</v-icon>현금 주문관리</v-tab>
        <v-tab><v-icon left small>mdi-file-document-multiple-outline</v-icon>코인 주문관리</v-tab>
        <v-tab><v-icon left small>mdi-atom</v-icon>코인/현금 상품관리</v-tab>
        <v-tab><v-icon left small>mdi-file-document-multiple-outline</v-icon>유저상품 구매내역</v-tab>
      </v-tabs>
    </v-card>

    <!-- v-tab-item 은 기본 지연 렌더링 → 탭을 처음 열 때 각 컴포넌트의 created() 가 실행된다 -->
    <v-tabs-items v-model="activeTab">
      <v-tab-item><CashOrderList /></v-tab-item>
      <v-tab-item><CoinOrderList /></v-tab-item>
      <v-tab-item><CoinProduct /></v-tab-item>
      <v-tab-item><UserBuyProducts /></v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
// 기존 4개 메뉴를 교환소 하나로 통합 — 각 컴포넌트는 수정 없이 그대로 재사용
import CashOrderList from './Game_CashOrderList.vue';
import CoinOrderList from './Game_CoinOrderList.vue';
import CoinProduct from './Game_CoinProduct.vue';
import UserBuyProducts from './Game_UserBuyProducts.vue';

export default {
  name: 'CPU_Exchange',
  components: { CashOrderList, CoinOrderList, CoinProduct, UserBuyProducts },
  data: () => ({
    activeTab: 0,
  }),
};
</script>
